const defaultState: any = null;

const workspaceDomainReducer = (state = defaultState, action: { type: string; payload: any }) => {
	switch (action.type) {
		case 'SET_WORKSPACE_DOMAIN':
			return action.payload;

		case 'CLEAR_WORKSPACE_DOMAIN':
			return null;

		default:
			return state;
	}
};

export default workspaceDomainReducer;
